import {useQuery} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'
import {B2BDashboardParams} from '../domain/entities/B2BDashboard.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

export function useB2BDashboard(params: B2BDashboardParams) {
    const query = useQuery({
        queryKey: ['b2b-dashboard', params.range, params.range === 'CUSTOM' ? params.from : null, params.range === 'CUSTOM' ? params.to : null, params.currency],
        queryFn: () => b2bMetricsRepository.getB2BDashboard(params),
        enabled: params.range !== 'CUSTOM' || (!!params.from && !!params.to),
    })

    return {
        dashboard: query.data,
        isLoadingDashboard: query.isLoading,
        isFetchingDashboard: query.isFetching,
        dashboardError: query.error,
    }
}
